import { getFormattedDateReverse } from '../../../utils/date';

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

/** Top of the left column, one line like the trip / activity review. */
export default function StaySummary({ stay }) {
    const { guests = {} } = stay;
    const guestText = [
        plural(guests.adults || 0, 'Adult', 'Adults'),
        guests.children ? plural(guests.children, 'Child', 'Children') : '',
        guests.pets ? plural(guests.pets, 'Pet', 'Pets') : ''
    ]
        .filter(Boolean)
        .join(', ');

    const items = [
        `${getFormattedDateReverse(stay.checkIn)} to ${getFormattedDateReverse(stay.checkOut)}`,
        `${stay.nights}N`,
        // several units: "Deluxe Tent × 1, Dorm Bed × 2"
        stay.items?.length > 1
            ? stay.items.map((i) => `${i.unitName || 'Room'} × ${i.rooms}`).join(', ')
            : `${stay.unitName || 'Room'} × ${stay.rooms}`,
        guestText,
        stay.location
    ].filter(Boolean);

    return (
        <div className='reviewBoInfoDetail'>
            <h3 className='reviewBoInfoPackName'>{stay.title}</h3>
            <div className='reviewBoInfoTextDiv'>
                {items.map((item, i) => (
                    <span key={item} className='reviewBoInfoTextDiv'>
                        {i > 0 && <span className='reviewBoInfoSpace' />}
                        <span className='reviewBoInfotext'>{item}</span>
                    </span>
                ))}
            </div>
        </div>
    );
}
